export const ANNOTATOR_QUEUE_TAG = 'annotator-queue';
